// Which cost figure the Azure Costs page displays. This is fixed by aggregation,
// not a user choice: daily figures show Amortized (Azure spreads reservation /
// savings-plan purchases across their term, so a purchase doesn't land as a
// one-day spike and a benefit expiring doesn't look like a sudden price
// increase); monthly and quarterly rollups always show Actual, because those
// totals are meant to reconcile with the Azure invoice, and Amortized
// recognizes a commitment's cost across the days it covers rather than by
// calendar month — a month/quarter total can diverge sharply from what was
// actually billed that period (e.g. the last covered month before a savings
// plan's term ends showed ~$4,700 of Amortized cost with $0 Actual, because
// the cash had already been billed the prior month for coverage that ran into
// this one).
export const COST_BASIS = {
  AMORTIZED: "amortized",
  ACTUAL: "actual",
};

export const costBasisLabel = (basis) =>
  basis === COST_BASIS.ACTUAL ? "Actual" : "Amortized";

export const basisForViewMode = (viewMode) =>
  viewMode === "daily" ? COST_BASIS.AMORTIZED : COST_BASIS.ACTUAL;

// A null/undefined amortized value means the row predates amortized capture, so
// fall back to actual cost. Falling back to 0 would draw as "no spend that day"
// and drag every rolling average down with it. A genuine zero (e.g. a
// reservation purchase row, whose spend is amortized into the usage rows) is
// stored as 0, not null, so it is left alone.
const pick = (amortized, actual, basis) => {
  if (basis === COST_BASIS.ACTUAL) return actual || 0;
  return amortized ?? actual ?? 0;
};

export const dailyCostOf = (item) => pick(item?.amortizedCost, item?.cost, COST_BASIS.AMORTIZED);

export const monthlyCostOf = (item) => pick(item?.monthlyAmortizedCost, item?.monthlyCost, COST_BASIS.ACTUAL);

export const quarterlyCostOf = (item) => pick(item?.quarterlyAmortizedCost, item?.quarterlyCost, COST_BASIS.ACTUAL);

// Value for whichever aggregation the page is currently showing.
export const costOfForViewMode = (item, viewMode) => {
  if (viewMode === "monthly") return monthlyCostOf(item);
  if (viewMode === "quarterly") return quarterlyCostOf(item);
  return dailyCostOf(item);
};
